import React, { Component } from "react";
import * as Yup from "yup";
import axios from "axios";
import * as Sentry from "@sentry/browser";

import i18n from "../../constants/i18n";

import ForgotPasswordFormView from "./ForgotPasswordFormView";
import createApiService from "../../network";
import ValidationError from "../../helpers/ValidationError";
import { extractApiErrorMessage } from "../../helpers";

class ForgotPasswordContainer extends Component {
    initialValues = {
        email: ""
    };

    validationSchema = Yup.object().shape({
        email: Yup.string()
            .email(i18n.validation.email)
            .required(i18n.validation.required)
    });

    onSubmit = async (values, formikBag) => {
        const api = createApiService(axios);

        try {
            await api.forgotPassword(values);

            formikBag.setSubmitting(false);
            formikBag.setStatus({ succeeded: true });
        } catch (e) {
            if (e instanceof ValidationError) {
                formikBag.setErrors(e.errors);
                formikBag.setSubmitting(false);
            } else {
                Sentry.captureException(e);
                console.error(e);
                formikBag.setSubmitting(false);
                this.props.showToast({
                    body: extractApiErrorMessage(e),
                    title: "Error",
                    themeClass: "is-danger"
                });
            }
        }
    };

    render() {
        return (
            <ForgotPasswordFormView
                initialValues={this.initialValues}
                validationSchema={this.validationSchema}
                onSubmit={this.onSubmit}
            />
        );
    }
}

export default ForgotPasswordContainer;
